import { doAction } from '@situation/setdesign.util';
import { HOOKS } from '../constants';
import Event from '../models/Event';

/**
 * Central state manager leveraging the global event system.
 * Emits namespaced actions on state changes and applies filters for data transformation.
 */
export default class StateManager {
    constructor() {
        /** @type {Array} */
        this.events = [];
        /** @type {Object.<number, Object>} */
        this.preferences = {};
        /** @type {boolean} */
        this.hasStarPrice = false;
    }

    /**
     * Stores events after applying filters, then emits a loaded action.
     * @param {Array} eventsData - Raw event objects or models
     */
    setEvents(eventsData) {
        const validEvents = [];
        eventsData.forEach((data) => {
            try {
                const event = new Event(data);
                validEvents.push(event);
            } catch (error) {
                console.error('Invalid event data:', error.message, data);
            }
        });

        this.events = validEvents.sort(Event.sortByStart);
    }

    getEventByID(eventID) {
        return this.events.filter((event) => event.id === eventID).shift();
    }

    /**
     * Updates a single preference and emits an update action.
     * @param {number} index
     * @param {Object} data - Partial preference (e.g. { event, section, people })
     */
    updatePreference(index, data) {
        // Transform incoming data if needed
        this.preferences[index] = { ...this.preferences[index], ...data };
        doAction(HOOKS.PREF_UPDATED, index, this.preferences[index]);
        this._checkStarPriceSelection();
    }

    /**
     * Checks if any preference has a '*' price and dispatches an event if the status changes.
     * @private
     */
    _checkStarPriceSelection() {
        const hasStar = Object.values(this.preferences).some((pref) => {
            if (!pref.event || !pref.section) {
                return false;
            }

            const pricingInfo = pref.event.pricing.find((p) => p.section === pref.section);
            return pricingInfo && pricingInfo.price === '*';
        });
        if (this.hasStarPrice !== hasStar) {
            this.hasStarPrice = hasStar;
            doAction(HOOKS.STAR_PRICE_STATUS_CHANGED, this.hasStarPrice);
        }
    }
}
